import UrlHelper from 'Libs/helpers/url';

export const PAIRED_ARTICLE_NUMBERS_ID = 'paired_article_numbers_1564';
export const RECOMMENDED_ACCESSORIES_ID =
  'part_number_of_recommended_accessories_1538';
export const REPLACED_BY_ID = 'replaced_by_10017';

const LINKABLE_ATTRIBUTE_IDS = new Set([
  PAIRED_ARTICLE_NUMBERS_ID,
  RECOMMENDED_ACCESSORIES_ID,
  REPLACED_BY_ID,
]);

export function normalizeAttributeValue(value) {
  if (typeof value === 'string') {
    return value.trim();
  }

  if (typeof value === 'number') {
    return String(value).trim();
  }

  if (value === null || value === undefined) {
    return '';
  }

  return '';
}

export function hasDisplayValue(value) {
  return normalizeAttributeValue(value).length > 0;
}

export function getAttributeCatalogSearchUrl({
  attributeId,
  articleNumber,
}) {
  const normalizedArticleNumber = normalizeAttributeValue(articleNumber);

  if (!normalizedArticleNumber) {
    return null;
  }

  if (!LINKABLE_ATTRIBUTE_IDS.has(attributeId)) {
    return null;
  }

  return UrlHelper.getCatalogSearchUrl([normalizedArticleNumber]);
}

export function getPairedArticle(attributes) {
  const pairedAttribute = (attributes || []).find(
    ({ id, value }) =>
      id === PAIRED_ARTICLE_NUMBERS_ID && hasDisplayValue(value)
  );

  if (!pairedAttribute) {
    return null;
  }

  const articleNumber = normalizeAttributeValue(pairedAttribute.value);

  return {
    articleNumber,
    link: UrlHelper.getCatalogSearchUrl([articleNumber]),
  };
}

export function getLinesWithAttributeLinks({
  lines = [],
  valueKey = 'value',
  idKey = 'id',
}) {
  return lines
    .filter((line) => hasDisplayValue(line?.[valueKey]))
    .map((line) => ({
      ...line,
      attributeLink: getAttributeCatalogSearchUrl({
        attributeId: line?.[idKey],
        articleNumber: line?.[valueKey],
      }),
    }));
}
